import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgArrowRight = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M14.55 17.672c-.3.304-.3.796 0 1.1a.76.76 0 0 0 1.086 0l6.14-6.222a.78.78 0 0 0 .166-.848.8.8 0 0 0-.167-.252l-6.14-6.222a.76.76 0 0 0-1.085 0c-.3.304-.3.796 0 1.1l4.83 4.894H2.767A.773.773 0 0 0 2 12c0 .43.344.778.767.778H19.38z"
      />
    </svg>
  );
};
export default SvgArrowRight;
